import React from 'react'

type Props = {
    className?  : string
    style?      : any

    size        : '18'| '22'| '26'| '30'| '32'| '36'| '40'| '54'| '100'

    onClick?    : func
}

export default function GoodDayUserIcon(props: Props) {

    let iconPath;
    let iconClass;

    switch (props.size) {
        // case '22':      iconClass = "avatar-22"; break;
        case '26'   :      iconClass = "size-26"; break
        case '32'   :      iconClass = "size-32"; break
        default     :
            return null
    }

    iconPath = gdConfig.assetsPath +'/skin/common/svg/gd-avatar.svg'

    const classes = Classes(iconClass, "gd-user mom", props.className)

    return (
        <div className={classes} onClick={props.onClick} onDragStart={()=>false} style={props.style}>
            <img src={iconPath} />
        </div>
    )
}
